import { TradingOffer } from 'types/TradingOffer';
import { TradingOfferOperation } from 'types/TradingOfferOperation';
import {
  Board,
  Committee,
  Communication,
  Council,
  Document,
  Folder,
  Guest,
  HoldingClass,
  Note,
  Operation,
  Partner,
  PartnerCategory,
  PartnerRepresentant,
  Realty,
  Share,
  SharesTitle,
  SideMenu,
  Society,
  StockPlan,
  TenderOffer,
  User,
} from 'types';
import { EnvelopeWithStatus } from 'types/Envelope';
import { AdminPermissions } from 'types/User';

export type State = {
  user: User;
  partnerBook: Record<string, any>;
  menu: SideMenu;
  sideNav: boolean;
  alerts: any[];
  documents: Document[];
  envelopes: EnvelopeWithStatus[];
  modal: any;
  society: {
    actualSociety: Society;
    role: Record<string, any>;
    permissions: AdminPermissions;
  };
  employees: Record<string, any>[];
  employeesPlans: Record<string, any>[];
  plans: StockPlan[];
  drafts: Record<string, any>[];
  holdingClasses: HoldingClass[];
  tenderOffers: TenderOffer[];
  tenderOffersShares: Record<string, any>[];
  boards: Board[];
  communications: Communication[];
  preview: Record<string, any>;
  notification: Record<string, any>;
  fullWidth: boolean;
  partnerCategories: PartnerCategory[];
  partnerRepresentants: PartnerRepresentant[];
  globalNotifications: Record<string, any>[];
  guests: Guest[];
  committees: Committee[];
  councils: Council[];
  realties: Realty[];
  sharesTitles: SharesTitle[];
  partners: Partner[];
  operations: Operation[];
  notes: Note[];
  shares: Share[];
  tradingOffers: TradingOffer[];
  tradingOfferOperations: TradingOfferOperation[];
  folders: Folder[];
  ai: {
    conversations: Array<{
      id: string;
      title: string;
      messageCount: number;
      updatedAt: string;
      createdAt: string;
    }>;
    currentConversation: {
      id: string | null;
      title: string;
      messages: Array<{
        id: string;
        role: 'user' | 'assistant';
        content: string;
        createdAt?: string;
        usage?: Record<string, any>;
      }>;
    };
    usage: {
      used: number;
      limit: number | null;
      percent: number;
      costUsd: number;
      messages: number;
      tier: string;
      yearMonth: string;
    } | null;
    isStreaming: boolean;
    streamingText: string;
    isHandoff: boolean;
  };
};

const initialState = {
  user: null,
  partnerBook: null,
  menu: { type: 'MAIN' },
  sideNav: false,
  alerts: [],
  documents: [],
  envelopes: [],
  modal: null,
  society: null,
  employees: [],
  employeesPlans: [],
  plans: [],
  drafts: [],
  holdingClasses: [],
  tenderOffers: [],
  tenderOffersShares: [],
  boards: [],
  communications: [],
  preview: null,
  notification: null,
  fullWidth: false,
  partnerCategories: [],
  partnerRepresentants: [],
  globalNotifications: [],
  guests: [],
  committees: [],
  councils: [],
  realties: [],
  sharesTitles: [],
  partners: [],
  operations: [],
  notes: [],
  shares: [],
  tradingOffers: [],
  tradingOfferOperations: [],
  folders: [],
  ai: {
    conversations: [],
    currentConversation: { id: null, title: '', messages: [] },
    usage: null,
    isStreaming: false,
    streamingText: '',
    isHandoff: false,
  },
};

export default initialState;
